import $ from "jquery";

import HasClass from "./helpers/hasClass";
import Homepage from "./pages/homepage";
import Navigation from "./helpers/navigation";
import Slider from "./helpers/slider";
import Drag from "./helpers/drag";
import Faq from "./helpers/faq";
import Hover from "./helpers/hover";
import Search from "./helpers/search";
import Filter from "./helpers/filter";
import Hash from "./helpers/hash";
import Contact from "./helpers/contact";
import Marquee from "./helpers/marquee";
import Draw from "./helpers/draw";
import Map from "./helpers/map";
import DragTitle from "./helpers/dragTitle";
import FilterEvents from "./helpers/filter-events";

const body = new HasClass("body");

class App {
  constructor() {
    this.injector = { app: this };

    this.navigation = new Navigation();
    this.search = new Search();
    this.contact = new Contact();
    this.hash = new Hash();
  }

  start() {
    $(document).mousemove(function (e) {
      $(".js-hover-image").css({ left: e.pageX + 20, top: e.pageY + 20 });
      $(".js-hover-image")
        .find(".js-bg-image")
        .css({ backgroundPositionX: -1 * e.pageX + 20 });
    });

    body.has("page-home", () => {
      this.home = new Homepage(this.injector);
    });

    body.has("page-events", () => {
      new Filter(this.injector);
    });

    body.has("page-praktisch", () => {
      new Map("#map");
    });

    body.has("page-workshops", () => {
      new FilterEvents();
    });

    body.has("page-faq", () => {
      new Faq();
    });

    $(".js-draw").each(function () {
      new Draw(this);
    });

    $(".js-contact-open").each((i, e) => {
      this.contact.addButton(e);
    });

    $(".js-foto-shuffle").each((i, e) => {
      if (!this.isMobileDevice()) {
        new Drag(e);
      }
    });

    $(".marquee").each(function () {
      new Marquee(this);
    });

    $(".js-title-slider").each(function () {
      new DragTitle(this);
    });

    $(".js-image-hover").each(function () {
      new Hover(this);
    });

    $(".js-video-banner").each(function (e) {
      $(this).on("click", (e) => {
        e.preventDefault();
        let $iframe = $(this).find("iframe");

        $(this).addClass("playing");

        $iframe.one("load");
        $iframe.attr("src", $iframe.data("src"));
      });
    });

    $(".js-toggle-newsletter").each(function () {
      $(this).on("click", (e) => {
        e.preventDefault();
        $(".js-newsletter").toggleClass("active");
      });
    });

    $(".js-locatie-slider").each(function () {
      var locatieSlider = new Slider(this, {
        prevNextButtons: false,
        wrapAround: false,
        touchVerticalScroll: false,
        adaptiveHeight: true,
        draggable: false,
      });

      $(".js-change-nav").on("click", (e) => {
        var index = $(e.currentTarget).index();
        $(".js-change-nav").removeClass("is-selected");
        $(e.currentTarget).addClass("is-selected");
        locatieSlider.goTo(index);
      });
    });

    $(".js-fotos-slider").each(function () {
      new Slider(this, {
        prevNextButtons: true,
        pageDots: false,
        imagesLoaded: true,
        wrapAround: true,
        touchVerticalScroll: false,
        adaptiveHeight: false,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        on: {
          ready: () => {
            $(this).addClass("show");
          },
        },
      });
    });
  }

  isMobileDevice() {
    return (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    );
  }
}

module.exports = new App();



// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/app.js